import React from 'react';
import { Form, DatePicker } from 'antd';
import moment from 'moment';
import { fieldNames } from './constants';
import useDebouncedFunc from '../../../../../../hooks/useDebounsedFunc';
import styles from './DocFormModal.module.scss';

const { Item: FormItem } = Form;

const disabledDate = (fromDate) => (current) => {
  const fromDateClone = fromDate?.clone()?.startOf('day');
  const currentClone = current?.clone()?.startOf('day');

  return fromDateClone && currentClone && currentClone.isBefore(fromDateClone);
};

const ToDateField = ({ form, initialValue }) => {
  const { getFieldDecorator, getFieldValue, isFieldTouched, validateFields } =
    form;

  const debounceValidateFromDate = useDebouncedFunc(() => {
    if (isFieldTouched(fieldNames.fromDate)) {
      validateFields([fieldNames.fromDate]);
    }
  }, 500);

  const compareFromDateField = (_rule, value, callback) => {
    const fromDate = getFieldValue(fieldNames.fromDate)
      ?.clone()
      ?.startOf('day');
    const cloneVal = value?.clone()?.startOf('day');

    if (!fromDate || !cloneVal) {
      callback();
      return;
    }

    if (cloneVal.isBefore(fromDate)) {
      callback('Дата окончания не может быть раньше даты публикации');
      return;
    }

    callback();
  };

  const handleChange = () => {
    debounceValidateFromDate();
  };

  return (
    <FormItem label="Дата окончания показа" colon={false}>
      {getFieldDecorator(fieldNames.toDate, {
        initialValue: initialValue ? moment(initialValue) : null,
        rules: [{ type: 'object', validator: compareFromDateField }],
      })(
        <DatePicker
          className={styles.fullWidth}
          format="DD.MM.YYYY"
          disabledDate={disabledDate(getFieldValue(fieldNames.fromDate))}
          onChange={handleChange}
        />
      )}
    </FormItem>
  );
};

export default ToDateField;
